import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() {
  }

  private notificationDefinition = {
    message: '',
    position: {
      my: 'center top',
      at: 'center top',
    },
  };
  private notificationDuration = 3000;

  showSuccessMessage(message: string): void {
    notify(this.getNotificationDefinition(message), 'success', this.notificationDuration);
  }

  showErrorMessage(message: string): void {
    notify(this.getNotificationDefinition(message), 'error', this.notificationDuration);
  }

  private getNotificationDefinition(message: string): any {
    const notificationDefinition = JSON.parse(JSON.stringify(this.notificationDefinition));
    notificationDefinition.message = message;
    return notificationDefinition;
  }
}
